export var ODBreadcrumbThemeType;
(function (ODBreadcrumbThemeType) {
    ODBreadcrumbThemeType["CoreUILike"] = "cui";
})(ODBreadcrumbThemeType || (ODBreadcrumbThemeType = {}));
//# sourceMappingURL=breadcrumbInterfaces.js.map